<script>
import BaseForm from './base-form'
import toolbar from '@/mixins/toolbar'
import { Action } from '@/common/constant'
const blockFeaturePopup = () => import(/* webpackChunkName: "block-feature-popup" */ '@/views/pages/teacher/touch-point/block/index.vue')
const limmitFeaturePopup = () => import(/* webpackChunkName: "limmit-feature-popup" */ '@/views/pages/teacher/touch-point/limmit/index.vue')

export default {
  name: 'BaseList',

  extends: BaseForm,

  mixins: [toolbar],

  data () {
    return {
      editMode: this.$enumeration.EditMode.View,
      selectedItems: [],
      multiSelection: false,
      detailPopupName: 'DetailPopup'
    }
  },

  beforeCreate () {
    this.detailPopups = new Map()
  },

  mounted () {
    this.initToolbar()
  },

  /**
   * @description Xóa hết popup của component đi
   */
  beforeUnmount () {
    const me = this

    me?.detailPopups?.clear()
    delete me.detailPopups
  },

  methods: {
    /**
     * @description Override BaseForm để loading dữ liệu
     */
    async loadFormData () {
      const me = this

      me.showMask()
      me.clearFilter()
      await me.loadData()
      me.hideMask()
    },

    /**
     * @description Xóa filter trên trang
     * @author PHNam
     */
    clearFilter () {},

    /**
     * @description Load dữ liệu
     * @author PHNam
     */
    async loadData () {},

    /**
     * @description Xử lý toolbar button
     * @param command Tên command
     * @param button Button vừa được click
     * @author PHNam
     */
    onToolbarItemClick (command, button) {
      const me = this
      const selectedItems = me.getSelectedItems(command)
      const commandName = me.$enumeration.CommandName

      switch (command) {
        case commandName.Add:
          me.onAdd()
          break

        case commandName.Edit:
          me.onEdit(selectedItems)
          break

        case commandName.Delete:
          me.onDelete(selectedItems)
          break

        default:
          me.onToolbarItemCustomClick(command, button)
      }
    },

    /**
     * @description Lấy ra danh sách bản ghi đang chọn
     * @param commandName command của Button, nếu command là Edit thì ở mode nào cũng chỉ lấy 1 bản ghi duy nhất
     * @author PHNam
     */
    getSelectedItems (commandName) {
      const me = this
      const isSelectedMultiRecords =
          Array.isArray(me.selectedItems) && me.selectedItems.length > 0
      let selectedItems = me.multiSelection
        ? me.selectedItems
        : isSelectedMultiRecords
          ? me.selectedItems[0]
          : null

      if (
        commandName === me.$enumeration.EditMode.Edit &&
        isSelectedMultiRecords
      ) {
        selectedItems = selectedItems[0]
      }

      return selectedItems
    },

    /**
     * @description Set các bản ghi đã chọn
     * @param selections Các bản ghi cần set
     * @author PHNam
     */
    setSelectedItems (selections) {
      const me = this
      if (!selections) {
        me.selectedItems = []
      } else {
        const isSelectedMultiRecords = Array.isArray(selections)

        if (me.multiSelection) {
          me.selectedItems = isSelectedMultiRecords ? selections : [selections]
        } else {
          me.selectedItems = isSelectedMultiRecords
            ? [selections[0]]
            : [selections]
        }
      }
    },

    /**
     * @description Xử lý khi các command khác
     * @param command Tên command
     * @param button Button vừa được click
     * @author PHNam
     */
    onToolbarItemCustomClick (command, button) {
      // console.log(command, button)
    },

    /**
     * @description Xử lý thêm mới
     * @author PHNam
     */
    onAdd () {
      const me = this
      const initData = me.getInitDetailData()
      me.showDetail(me.detailPopupName, initData, me.$enumeration.EditMode.Add)
    },

    /**
     * @description Xử lý sửa
     * @param payload Thông tin về bản ghi được sửa
     * @author PHNam
     */
    onEdit (payload) {
      const me = this
      if (payload) {
        me.showDetail(
          me.detailPopupName,
          payload,
          me.$enumeration.EditMode.Edit
        )
      } else {
        me.warningNoSelectedItem()
      }
    },

    /**
     * @description Thực hiện show popup detail
     * @param componentName Tên popup component
     * @param payload Dữ liệu gửi sang form
     * @param editMode
     * @author PHNam
     */
    async showDetail (componentName, payload, editMode) {
      const me = this

      const show = await me.validateBeforeShow(payload, editMode)
      if (show) {
        const success = await me.initPopupInstance(componentName)

        if (success) {
          const detailData = me.getDetailData(payload)

          const popup = me.detailPopups.get(componentName)
          const data = {
            config: {
              editMode: editMode,
              parent: me
            },
            params: detailData
          }

          popup.initForm(data)
          popup.open()
        }
      }
    },

    /**
     * @description Khởi tạo popup
     * @param componentName Tên popup component
     * @author PHNam
     */
    async initPopupInstance (componentName) {
      const me = this
      let success = true

      if (!me.detailPopups.has(componentName)) {
        me.showMask()
        const popupComponent = await me.getDetailComponent(componentName)
        const props = me.getPopupProps(componentName)
        me.hideMask()

        if (popupComponent && popupComponent.default) {
          const instance = me.$commonFn.getComponentInstance(popupComponent, props)
          if (instance) {
            // Tạo div chứa để mount component ra
            const container = document.createElement('div')
            const popupInst = instance.mount(container)
            const dialogEl = container.firstElementChild

            if (dialogEl) {
              dialogEl.setAttribute(instance._component.__scopeId, '')
              document.documentElement.appendChild(dialogEl)
            }
            me.detailPopups.set(componentName, popupInst)
          } else {
            success = false
          }
        } else {
          success = false
        }
      }

      return success
    },

    /**
     * @description Lấy prop truyền cho popup
     * @param componentName
     * @author PHNam
     */
    getPopupProps (componentName) {
      return {}
    },

    /**
     * @description Xử lý trước khi show popup detail, return false để không show popup
     * @param payload Thông tin bản ghi
     * @param editMode
     * @author PHNam
     */
    async validateBeforeShow (payload, editMode) {
      // Check quyền (nghiệp vụ)
      // console.log(payload)
      // console.log(editMode)
      return true
    },

    /**
     * @abstract
     * @description Trả về component sẽ hiển thị khi thêm, sửa ở màn hình danh sách
     * @param componentName Tên popup component
     * @author PHNam
     */
    async getDetailComponent (componentName) {
      const me = this

      if (componentName === me.detailPopupName) {
        return me.getDetailPopup()
      } else {
        return me.getOtherPopup(componentName)
      }
    },

    /**
     * @description Trả về component deatail (thêm sửa)
     * @author PHNam
     */
    async getDetailPopup () {
      return null
    },

    /**
     * @description Trả về các component khác form thêm sửa
     * componentName Tên popup component
     * @author PHNam
     */
    async getOtherPopup (componentName) {
      // console.log(componentName)
      return null
    },

    /**
     * @abstract
     * @description Trả về dữ liệu gửi sang detail
     * @param payload Dữ liệu gửi lên popup
     * @author PHNam
     */
    getDetailData (payload) {
      return payload
    },

    /**
     * @abstract
     * @description Trả về dữ liệu khi tạo mới
     * @author PHNam
     */
    getInitDetailData () {
      return {}
    },

    /**
     * @description Xử kiện ở cột chức năng
     * @param payload Dữ liệu gửi ra gồm command và dataRow
     * @author PHNam
     *  */
    executeCommand (payload) {
      const me = this
      const editMode = me.$enumeration.EditMode

      switch (payload.commandName) {
        case editMode.Edit:
          me.onEdit(payload.data)
          break
        case editMode.Delete:
          me.onDelete(payload.data)
          break
      }
    },

    /**
     * @description Khi thực hiện xóa bản ghi
     * @param payload Dữ liệu xóa
     * @author PHNam
     */
    async onDelete (payload) {
      const me = this

      if (payload) {
        const allowDelete = await me.validateDelete(payload)

        if (allowDelete) {
          me.confirmDelete(payload)
        }
      } else {
        me.warningNoSelectedItem()
      }
    },

    /**
     * @description Xác nhận xóa
     * @param payload Dữ liệu xóa
     * @author PHNam
     */
    confirmDelete (payload) {
      const me = this
      const container = me.getContainer()
      const isMultipleRecords = Array.isArray(payload) && payload.length > 1
      const deleteRecords = isMultipleRecords ? payload : payload?.[0] || payload

      me.$message.show(me.getMessageBoxDeleteOption(payload))
        .then(() => {
          const deleleFn = isMultipleRecords ? me.deleteMultiple : me.delete

          me.$commonFn.showMask(container)
          deleleFn(deleteRecords)
            .then((success) => {
              me.afterDelete(success)
            })
            .catch((error) => {
              me.$commonFn.handleNetworkError(error)
            })
        })
        .catch((err) => {
          console.error(err)
        })
        .finally(() => {
          me.$commonFn.hideMask(container)
        })
    },

    /**
     * @description Lấy message thông báo xóa
     * @param {Boolean} isMultiple Xóa nhiều bản ghí
     * @author PHNam
     */
    getMessageBoxDeleteOption (payload) {
      const me = this
      const isMultiple = Array.isArray(payload) && payload.length > 1
      const config = me.moduleConfig

      return {
        type: 'confirm',
        title: me.$t('NotifyMessage.Warning'),
        message: me.$t(
          isMultiple
            ? 'NotifyMessage.ConfirmDeleteMultiple'
            : 'NotifyMessage.ConfirmDelete',
          {
            entityName: me.$t(`Entity.${config.entityName}`)
          }
        ),
        confirmButtonText: me.$t('Button.Agree'),
        cancelButtonText: me.$t('Button.Cancel'),
        showCancelButton: true,
        dangerouslyUseHTMLString: true
      }
    },

    /**
     * @description Cảnh báo chưa chọn bản ghi nào
     * @author PHNam
     */
    warningNoSelectedItem () {
      this.$notify({
        title: this.$t('NotifyMessage.Title'),
        message: this.$t('NotifyMessage.NoneRecordsSelected'),
        type: 'warning'
      })
    },

    /**
     * @description Validate trước khi xóa
     * @param payload Dữ liệu đem xóa
     * @author PHNam
     */
    async validateDelete (payload) {
      // console.log(payload)
      return true
    },

    /**
     * @description Xóa dữ liệu
     * @param payload
     * @author PHNam
     */
    async delete (payload) {
      const me = this
      const config = me.moduleConfig

      return me.$store.dispatch(
        `${config.moduleName}/${Action.DELETE}${config.entityName}`,
        payload[config.entityKey]
      )
    },

    /**
     * @description Xóa dữ liệu
     * @param payload
     * @author PHNam
     */
    async deleteMultiple (payload) {
      const me = this
      const config = me.moduleConfig
      const itemsId = payload.map((item) => item[config.entityKey])

      return me.$store.dispatch(
        `${config.moduleName}/${Action.DELETE}${config.entityName}s`,
        itemsId
      )
    },

    /**
     * @description Xử lý sau khi xóa thành công
     * @param success Xóa thành công
     * @author PHNam
     */
    afterDelete (success) {
      const me = this

      me.$notify.showSuccess({
        title: me.$t('NotifyMessage.Title'),
        message: success
          ? me.$t('NotifyMessage.DeleteSuccess')
          : me.$('NotifyMessage.ErrorOccurred'),
        type: success ? 'success' : 'error'
        // position: 'bottom-right'
      })
      if (success) {
        me.selectedItem = null
      }
    },

    /**
     * @desciption Hàm kiểm tra tính năng trong config rankingConfig có được mở hay không
     *            - Nếu là tính năng bị khóa hoặc hạn chế sẽ show popup tương ứng
     *            - Nếu có callback truyền vào sẽ thực hiện call back và không show popup nữa
     * @param callBack callback thực hiện
     * @param dataConfig data truyền sang popup được show
     * @author NTQuy
     */
    async checkingTeacherRanking (callBack, dataConfig) {
      const me = this
      const resultCheck = await me.checkRankingConfig()

      if (!resultCheck) {
        if (!callBack) {
          await me.initCheckingPopups()

          dataConfig.featureActiveRank = me.rankingConfig.featureActiveRank
          const data = {
            params: dataConfig
          }

          const popupInst = me.detailPopups.get('rankingPopup')
          popupInst.initForm(data)
          popupInst.open()
        } else {
          callBack()
        }

        // eslint-disable-next-line no-throw-literal
        throw 'Ending execution'
      }
    },

    async initCheckingPopups () {
      const me = this
      let popupComponent = null

      if (me.rankingConfig?.featureName) {
        popupComponent = await blockFeaturePopup()
      } else {
        popupComponent = await limmitFeaturePopup()
      }

      const instance = me.$commonFn.getComponentInstance(popupComponent)
      if (instance) {
        // Tạo div chứa để mount component ra
        const container = document.createElement('div')
        const popupInst = instance.mount(container)
        const dialogEl = container.firstElementChild

        if (dialogEl) {
          dialogEl.setAttribute(instance._component.__scopeId, '')
          document.documentElement.appendChild(dialogEl)

          me.detailPopups.set('rankingPopup', popupInst)
        }
      }
    }
  }
}
</script>
